import { Info } from 'lucide-react';
import { HoverCard, HoverCardContent, HoverCardTrigger } from '@/components/ui/hover-card';

export function InfoHoverCard({ message }: { message: string }): JSX.Element {
  return (
    <HoverCard openDelay={120} closeDelay={80}>
      <HoverCardTrigger asChild>
        <button
          type="button"
          className="inline-flex h-5 w-5 items-center justify-center rounded-full text-muted-foreground transition-colors hover:text-foreground"
          aria-label="Show review guidance"
        >
          <Info className="h-3.5 w-3.5" />
        </button>
      </HoverCardTrigger>
      <HoverCardContent align="start" side="top" className="w-72">
        <div className="font-semibold text-foreground">Review Guidance</div>
        <div className="mt-1 whitespace-pre-wrap text-xs leading-5 text-muted-foreground">
          {message}
        </div>
      </HoverCardContent>
    </HoverCard>
  );
}
